// extracted by mini-css-extract-plugin
export default {"container":"FileUploadDropZone_container__7E-Sg","error":"FileUploadDropZone_error__+NOjC","textWrapper":"FileUploadDropZone_textWrapper__htekG"};